module.exports = __webpack_public_path__ + "media/images/record-circle-21693b4c71b087ed6ff057ad5e7371cc.svg";